var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isNeedShowAct && _setup.isLoadSuccess)?_c(_setup.CardContainer,{directives:[{name:"stat",rawName:"v-stat.brow",value:({
    tag: 'wepoints-module.index|积分模块',
    ext: _setup.getBiExt(),
  }),expression:"{\n    tag: 'wepoints-module.index|积分模块',\n    ext: getBiExt(),\n  }",modifiers:{"brow":true}}],staticClass:"wepoints-container",class:{'spring-act': _setup.isInSpring }},[_c(_setup.WePoints,{attrs:{"spId":_setup.spId,"adtag":"merchantChannel","lang":_setup.lang,"dpPositonInfo":{
      dpPage: _setup.DP_PAGE,
      dpPositions: [_setup.WE_POINTS_DP_POSITION],
    }},on:{"initDone":_setup.handleInitDone}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }